"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCookies = function (cookiesString) {
    var cookiesObject = {};
    var pairs = cookiesString.split(/; */);
    for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i];
        var eqIdx = pair.indexOf('=');
        // skip things that don't look like key=value
        if (eqIdx < 0) {
            continue;
        }
        var key = pair.substr(0, eqIdx).trim();
        // tslint:disable-next-line:restrict-plus-operands
        var value = pair.substr(eqIdx + 1, pair.length).trim();
        // quoted values
        if (value[0] === '"') {
            value = value.slice(1, -1);
        }
        // only assign once
        if (!(key in cookiesObject)) {
            cookiesObject[key] = decodeURIComponent(value);
        }
    }
    return cookiesObject;
};



//////////////////
// WEBPACK FOOTER
// ./src/shared/cookie.ts
// module id = 4
// module chunks = 0